// extracted by mini-css-extract-plugin
export default {"col_box":"index_col_box_ALID9","col_navlist":"index_col_navlist_iy3MU","pa":"index_pa_mdnUD"};